var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTemplateInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Template_Icon",
    "data-name": "Template Icon",
    d: "M-5881,19468a1,1,0,0,1-1-1v-16a1,1,0,0,1,1-1h16a1,1,0,0,1,1,1v16a1,1,0,0,1-1,1Zm.8-1.8h14.4v-14.4h-14.4Zm9.2-2.2a1,1,0,0,1-1-1v-3.8a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v3.8a1,1,0,0,1-1,1Zm-6,0a1,1,0,0,1-1-1v-3.8a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v3.8a1,1,0,0,1-1,1Zm-.1-8.2a.9.9,0,0,1-.9-.9.9.9,0,0,1,.9-.9h8.2a.9.9,0,0,1,.9.9.9.9,0,0,1-.9.9Z",
    transform: "translate(5882.001 -19450.002)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTemplateInactive);
export default __webpack_public_path__ + "static/media/menu_template_inactive.3ee0e0b70d36622fb33f5895921eec66.svg";
export { ForwardRef as ReactComponent };